import { useTranslation } from "react-i18next";

import PlusButton from "src/core/assets/images/icons/plus.svg?react";
import ReloadButton from "src/core/assets/images/icons/reload.svg?react";
import { AlertWithIcon } from "src/core/components/custom-ui/alert-with-icon";
import { StakeholderDocumentModal } from "src/core/components/folder/stakeholders/StakeholderDocumentModal";
import { StakeholderDuplicatesModal } from "src/core/components/folder/stakeholders/StakeholderDuplicatesModal";
import { UpdateStakeholderModal } from "src/core/components/folder/stakeholders/UpdateStakeholderModal";
import { StakeholdersDataTable } from "src/core/components/stakeholders-datatable/StakeholdersDataTable";
import { Button } from "src/core/components/ui/button";
import { MappedStakeholder } from "src/core/constants/folder";
import { useStakeholdersTable } from "src/core/hooks/folder/useStakeholdersTable";
import { cn } from "src/core/lib/utils";

export const FolderStakeholders = () => {
  const { t } = useTranslation();
  const {
    columns,
    data,
    loading,
    isLegalRepresentative,
    selectedStakeholderForEdit,
    openModalAddBasicStakeholder,
    isReadOnly,
    openUpdateModal,
    setOpenUpdateModal,
    displayReloadButton,
    handleCallEReputation,
    openStakeholderDocumentModal,
    setOpenStakeholderDocumentModal,
    documentToUpload,
    isPPH,
    openDuplicateCheckModal,
    setOpenDuplicateCheckModal,
    selectedStakeholderForDuplicateCheck,
  } = useStakeholdersTable();

  return (
    <div className="folder-stakeholders-wrapper">
      {!isLegalRepresentative && !isPPH && (
        <AlertWithIcon
          icon="1"
          title=""
          description={t("folder.stakeholders.legalRepresentativeAlertDescription")}
          variant="destructive"
          className="mx-0 mb-10"
        />
      )}
      <div className="folder-stakeholders-content">
        <StakeholdersDataTable columns={columns} data={data} isLoading={loading} />
      </div>

      {!isReadOnly && (
        <div className={cn("mt-10 flex flex-row justify-between", { "justify-end": isPPH })}>
          {!isPPH && (
            <Button variant="default" onClick={openModalAddBasicStakeholder}>
              <PlusButton />
              {t("folder.stakeholders.addStakeholder")}
            </Button>
          )}
          {displayReloadButton && (
            <div className="flex flex-row items-center gap-x-10 text-right font-light text-orange-medium">
              <p>{t("folder.entities.reloadMessage")}</p>
              <Button
                className={cn("mr-50 w-[110px]", { "mr-0": isPPH })}
                variant="destructive"
                onClick={handleCallEReputation}
              >
                <div className="flex items-center gap-x-10 w-full">
                  <ReloadButton />
                  <div className="flex-1 overflow-hidden line-clamp-2 break-words whitespace-normal text-left">
                    {t("folder.entities.reload")}
                  </div>
                </div>
              </Button>
            </div>
          )}
        </div>
      )}
      {selectedStakeholderForEdit && (
        <UpdateStakeholderModal
          open={openUpdateModal}
          setOpen={setOpenUpdateModal}
          stakeholder={selectedStakeholderForEdit as MappedStakeholder}
          isPPH={isPPH}
        />
      )}
      {selectedStakeholderForEdit && documentToUpload && (
        <StakeholderDocumentModal
          open={openStakeholderDocumentModal}
          setOpen={setOpenStakeholderDocumentModal}
          stakeholder={selectedStakeholderForEdit as MappedStakeholder}
          documentToUpload={documentToUpload}
        />
      )}
      {selectedStakeholderForDuplicateCheck && (
        <StakeholderDuplicatesModal
          open={openDuplicateCheckModal}
          setOpen={(open) => setOpenDuplicateCheckModal(open)}
          stakeholder={selectedStakeholderForDuplicateCheck as MappedStakeholder}
        />
      )}
    </div>
  );
};
